import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import {
  Storefront as StorefrontIcon,
  AccountBalance as AccountBalanceIcon,
} from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s ease-in-out',
    minHeight: '190px',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
    },
  },
  cardContent: {
    padding: theme.spacing(3),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: '2rem',
    marginRight: theme.spacing(2),
  },
  salesIcon: {
    color: '#FF6B35',
  },
  depositIcon: {
    color: '#4CAF50',
  },
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    color: '#666',
    margin: 0,
  },
  amount: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: '#333',
    margin: 0,
  },
  currency: {
    fontSize: '0.875rem',
    color: '#999',
    marginLeft: theme.spacing(1),
  },
}));

function DashboardCards({ totalSellAmount = 0, totalDepositAmount = 0 }) {
  const classes = useStyles();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <Grid container spacing={4} justify="flex-start">
      <Grid item xs={3} sm={4} md={3}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Box className={classes.iconContainer}>
              <StorefrontIcon className={`${classes.icon} ${classes.salesIcon}`} />
              <Typography variant="h6" className={classes.title}>
                Total Ventas
              </Typography>
            </Box>
            <Box display="flex" alignItems="baseline">
              <Typography variant="h4" className={classes.amount}>
                {formatCurrency(totalSellAmount).replace('MX$', '')}
              </Typography>
              <Typography variant="body2" className={classes.currency}>
                (MXN)
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={3} sm={4} md={3}>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Box className={classes.iconContainer}>
              <AccountBalanceIcon className={`${classes.icon} ${classes.depositIcon}`} />
              <Typography variant="h6" className={classes.title}>
                Total Depósito
              </Typography>
            </Box>
            <Box display="flex" alignItems="baseline">
              <Typography variant="h4" className={classes.amount}>
                {formatCurrency(totalDepositAmount).replace('MX$', '')}
              </Typography>
              <Typography variant="body2" className={classes.currency}>
                (MXN)
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

DashboardCards.defaultProps = {
  totalSellAmount: 0,
  totalDepositAmount: 0,
};

DashboardCards.propTypes = {
  totalSellAmount: PropTypes.number,
  totalDepositAmount: PropTypes.number,
};

export default DashboardCards;
